import { useCallback } from 'react';

import { useToast } from '../../hooks/useToast';

export const useTaxonomyVersionToast = () => {
  const toast = useToast();

  return useCallback(
    (id: string, filterName: string) => {
      if (!toast.isActive(id)) {
        toast({
          title: `Your ${filterName.toLowerCase()} filters were removed due to taxonomy changes. Please re-select them.`,
          status: 'warning',
          duration: 6000,
          isClosable: true,
          position: 'top-right',
          id,
        });
      }
    },
    [toast]
  );
};
